import styled from 'styled-components';

import React from 'react';

const Div = styled.div`
    border-bottom: 1px solid ${(props) => props.theme.colorTableHeaderBackground};
    padding-bottom: 10px;
    margin-bottom: 12px;
    color: ${(props) => props.theme.secondaryFontColor};
    font-weight: 700;
    font-size: 18px;
    font-family: 'Poppins';
`;

const FormHeading = ({ children, className, ...rest }) => {
    return <Div className={className} {...rest}>{children}</Div>;
};

export default FormHeading;
